import React, { Component } from 'react'
import classnames from "classnames";

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

import pic1 from './../../img/tutorial/monkey1@3x.png';
import pic2 from './../../img/tutorial/monkey2@3x.png';
import zen from './../../img/tutorial/zen@3x.png';
import finger from './../../img/tutorial/finger@3x.png';

class TutorialStep9 extends Component {
  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step9)}>
        <div className={classnames(grid.row, baseStyles.mb_30)}>
          <div className={classnames(grid.col_3)}>
              <img className={baseStyles.pic1} src={pic1} alt="monkey" width="161px" />
          </div>
          <div className={classnames(grid.col_9)}>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li>Always use a VPN <span className={baseStyles.danger}>before</span> accessing the Client’s dashboard;</li>
              <li><span className={baseStyles.block}>Order instructions will tell you how to access the required</span> task on the dashboard;</li>
              <li><span className={baseStyles.block}>Make a screenshot showing the completed task & upload it</span> to the “Final paper” section.</li>
            </ul>

            <div className={classnames(grid.row, baseStyles.mb_30)}>
              <div className={classnames(grid.col_2)}>
                <img className={baseStyles.pic3} src={zen} alt="zenmate" width="70px" />
              </div>
              <div className={classnames(grid.col_10)}>
                <p>We recommend using a free version of ZenMate.</p>
                <strong>Check its How-to guide<a href="https://zenguard.zendesk.com/hc/en-us/articles/202091932-Getting-started-with-ZenMate-VPN-for-browsers%2520first" target="_blank" rel="noopener noreferrer">here;</a></strong>
              </div>
            </div>
          </div>
        </div>

        <img className={baseStyles.pic2} src={pic2} alt="monkey" width="154px" />

        <div className={baseStyles.remember_block}>
          <img src={finger} alt="finger" width="54px" />
          <p>
            N.B.:<span className={baseStyles.danger2}>When you start working on a dashboard task</span>, <br /> it is obligatory to <span className={baseStyles.danger2}>change your IP to the US one</span> <br />to prevent our Clients' universities from noticing <br />that someove is trying to reach a student’s account <br />from a different country. <br/>
            <br />
            Note that there is <span className={baseStyles.danger2}>no need to turn on your VPN now</span>! 😉
          </p>
        </div>

      </div>
    )
  }
}

export default TutorialStep9;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep9.js